export const GuideIcon = ({ className }) => (<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className={className}>
    <circle cx="6.5" cy="5.5" r="2.5" stroke="#050505" strokeWidth="1.5"/>
    <circle cx="9" cy="19" r="2" stroke="#050505" strokeWidth="1.5"/>
    <circle cx="18" cy="10" r="2" stroke="#050505" strokeWidth="1.5"/>
    <path d="M19.5 14C20.5 16.5 18 20.5 13.5 20" stroke="#050505" strokeWidth="1.5" strokeDasharray="2 2"/>
    <path d="M10.5 3.50006C13.5 2.5 14.5 2.50001 16.5 5.99998" stroke="#050505" strokeWidth="1.5" strokeDasharray="2 2"/>
  </svg>);
